import { User, Bell, Link } from 'lucide-react'

import { IProfileMenuItemProps } from './ProfileMenu.types'

// Factory function to create menu items
export const createMenuItems = (
    handleMenuItemClick: (screen: 'profile' | 'notification-settings' | 'connect') => void,
    userRole: string,
): Omit<IProfileMenuItemProps, 'showDivider'>[] => {
    const baseItems = [
        {
            icon: User,
            label: 'Profile',
            onClick: () => handleMenuItemClick('profile'),
        },
        {
            icon: Bell,
            label: 'Notification Settings',
            onClick: () => handleMenuItemClick('notification-settings'),
        },
    ]

    // Add Connect option for HR users only
    if (userRole === 'hr') {
        baseItems.push({
            icon: Link,
            label: 'Connect',
            onClick: () => handleMenuItemClick('connect'),
        })
    }

    return baseItems
}
